'use client'

import React, { useState } from 'react'
import { SlidersHorizontalIcon } from 'lucide-react'

import { FilterSidebar, type FilterSidebarRefinementEnabled } from '@/components/assets-explorer/filters/filter-sidebar'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { ScrollArea } from '@/components/ui/scroll-area'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import useFilterSummary from '@/components/assets-explorer/filters/use-filter-summary'

type MobileFiltersPanelProps = {
  className?: string
  refinementEnabled?: FilterSidebarRefinementEnabled
}

export default function MobileFiltersPanel({ className, refinementEnabled = true }: MobileFiltersPanelProps) {
  const [open, setOpen] = useState(false)
  const { appliedFiltersCount } = useFilterSummary(refinementEnabled)

  return (
    <div className={cn('tw-flex tw-justify-end md:tw-hidden', className)}>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
          <Button
            type="button"
            size="sm"
            variant="ghost-stroke"
            className="tw-relative tw-gap-2 tw-whitespace-nowrap"
          >
            <SlidersHorizontalIcon className="tw-h-4 tw-w-4" />
            Filters
            {!!appliedFiltersCount && (
              <span className="tw-ml-1 tw-min-w-5 tw-rounded-full tw-bg-[#F36C17] tw-px-1.5 tw-py-0.5 tw-text-xs tw-leading-none tw-text-white">
                {appliedFiltersCount}
              </span>
            )}
          </Button>
        </DialogTrigger>
        <DialogContent className="!tw-left-0 !tw-top-0 !tw-grid !tw-h-[100dvh] !tw-w-screen !tw-max-w-none !tw-translate-x-0 !tw-translate-y-0 !tw-grid-rows-[auto_1fr] !tw-gap-3 !tw-overflow-hidden !tw-rounded-none !tw-bg-[var(--Primary)] !tw-bg-none !tw-p-4">
          <DialogHeader className="tw-pr-10 tw-text-left">
            <DialogTitle>Filters</DialogTitle>
            <DialogDescription className="tw-sr-only">Filter the current asset results.</DialogDescription>
          </DialogHeader>
          <ScrollArea className="tw-h-full tw-min-h-0 tw-rounded tw-bg-[var(--Primary)]">
            <FilterSidebar presentation="panel" refinementEnabled={refinementEnabled} />
          </ScrollArea>
        </DialogContent>
      </Dialog>
    </div>
  )
}
